import React from 'react';

import styled from '@emotion/styled';

import LoaderImg from 'assets/Loading.gif';

interface LoaderProps {
  customHeight?: string;
  backgroundColor?: string;
}

const StyledLoaderDiv = styled.div<LoaderProps>`
  background-color: red;
  display: flex;
  justify-content: center;
  align-items: center;

  @media (max-width: 768px) {
    .loaderImg {
      height: 15%;
    }
  }

  @media (min-width: 768px) {
    .loaderImg {
      height: 25%;
    }
  }
`;

const StyledOverlayDiv = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 101;
  background: rgb(0, 0, 0, 0.5);
`;

const ChatbotLoader = ({ customHeight, backgroundColor }: LoaderProps) => {
  customHeight = customHeight || 'calc(100vh - 65px)';
  backgroundColor = backgroundColor || 'transparent';
  return (
    <StyledLoaderDiv style={{ height: customHeight, backgroundColor: backgroundColor }}>
      <img className='loaderImg' src={LoaderImg} alt='loader-img' />
    </StyledLoaderDiv>
  );
};

export const ChatbotOverlayLoader = ({ customHeight }: LoaderProps) => {
  customHeight = customHeight || '100%';
  return (
    <StyledOverlayDiv>
      <ChatbotLoader backgroundColor='var(--translucent-white)' customHeight={customHeight} />
    </StyledOverlayDiv>
  );
};

export default ChatbotLoader;
